import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared/services/user.service";
import { PersonSelectorService } from "../../personselector/personselector.service";

import { DataService_idprint } from "./shared/data.service";
import { wsPrintQueueInfo } from "./shared/wsPrintQueueInfo";
import { wsPrintSchoolOptionsInfoParm } from "./shared/wsPrintSchoolOptionsInfoParm";
import { wsPrintSchoolOptionsInfo } from "./shared/wsPrintSchoolOptionsInfo";
import { wsPrintSchoolPrinterInfo } from "./shared/wsPrintSchoolOptionsInfo";
import { wsPrintSchoolTemplateInfo } from "./shared/wsPrintSchoolOptionsInfo";
import { wsPrintQueueInsertParm } from "./shared/wsPrintQueueInsertParm";
import { wsPersonInfo } from "./shared/wsPrintQueueInsertParm";
import { wsPrintQueueDeleteParm } from "./shared/wsPrintQueueDeleteParm";
import { wsDeleteInfo } from "./shared/wsPrintQueueDeleteParm";
import { wsPrintQueueCancelParm } from "./shared/wsPrintQueueCancelParm";
import { wsCancelInfo } from "./shared/wsPrintQueueCancelParm";

import { SetPrinterComponent } from "./setprinter/setprinter.component";
import { SetCardComponent } from "./setcard/setcard.component";
import { SetFeeComponent } from "./setfee/setfee.component";
import { PrintComponent } from "./print/print.component";

import { ViewChild } from "@angular/core";
import { Dropdown } from "primeng/dropdown";
import { LocalstorageService } from "../../../shared";

@Component({
	selector: "app-root",
	templateUrl: "./idprint.component.html",
	styleUrls: ["./idprint.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class IDPrintComponent implements OnInit, OnDestroy {
	@ViewChild("filterHasPhoto", { static: false })
	public filterHasPhoto: Dropdown;
	@ViewChild("filterIsStaffDesc", { static: false })
	public filterIsStaffDesc: Dropdown;
	@ViewChild("filterCardName", { static: false })
	public filterCardName: Dropdown;
	@ViewChild("filterIDCardStockDesc", { static: false })
	public filterIDCardStockDesc: Dropdown;
	@ViewChild("filterPrinterName", { static: false })
	public filterPrinterName: Dropdown;
	@ViewChild("filterIDPrintQueueStatusDesc", { static: false })
	public filterIDPrintQueueStatusDesc: Dropdown;

	constructor(
		private dataService: DataService_idprint,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private personselectorService: PersonSelectorService,
		private dialogService: DialogService,
		private localService: LocalstorageService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public isShowCardStock: boolean = false;
	public DefaultFee: number = 0;
	public isExpressIDCardPrintingMode: boolean = false;

	//	School Options/Selectors (Printers, Templates, Fees)
	public rPrintSchoolOptions: wsPrintSchoolOptionsInfo;
	public lstPrinter: wsPrintSchoolPrinterInfo[] = [];
	public lstStaffTemplate: wsPrintSchoolTemplateInfo[] = [];
	public lstStudentTemplate: wsPrintSchoolTemplateInfo[] = [];
	public SelectedPrinter: wsPrintSchoolPrinterInfo;
	public SelectedStudentTemplate: wsPrintSchoolTemplateInfo;
	public SelectedStaffTemplate: wsPrintSchoolTemplateInfo;

	//	Person Selector
	private subscriptionPersonSelect: Subscription;
	private subscriptionPersonSelectMultiple: Subscription;
	private subscriptionSchoolSelect: Subscription;
	private subscriptionAudienceSelect: Subscription;

	public SelectedPerson: any; // From Person Selector
	public lstSelectedPerson: any = []; // From Person Selector
	public SelectedSchool: any; // From Person Selector
	public SelectedAudience: number = 1; // From Person Selector
	public PrevSelectedSchool: any;

	//	PrintQ List
	public lstPrintQueue: wsPrintQueueInfo[] = [];
	public rPrintQueueItem: wsPrintQueueInfo;
	public lstPrintQueueChecked: wsPrintQueueInfo[] = [];

	//	Filters
	public lstPersonTypes: any = [];
	public lstCardNames: any = [];
	public lstCardStocks: any = [];
	public lstPrinterNames: any = [];
	public lstPrintQueueStatuses: any = [];
	public lstHasPhoto: any = [];

	//	PrintQ Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	public PrinterPref: string = "";
	public LoadedPreference: any;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.subscriptionAudienceSelect = this.personselectorService.onAudienceIdChange().subscribe((audienceid) => {
			this.SelectedAudience = audienceid;

			this.Printer_UpdatePreferenceKey();
			this.Printer_GetPreference();
		});

		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
		});

		this.subscriptionPersonSelectMultiple = this.personselectorService.onSelectedMultiplePersons().subscribe((lstperson: any) => {
			this.lstSelectedPerson = lstperson;
			this.onAdd();
		});

		this.subscriptionSchoolSelect = this.personselectorService.onSchoolSelectedChange().subscribe((school) => {
			let isSchoolChange: boolean = false;

			this.PrevSelectedSchool = this.SelectedSchool;
			this.SelectedSchool = school;

			this.Printer_UpdatePreferenceKey();
			this.Printer_GetPreference();

			if (this.PrevSelectedSchool == null || this.PrevSelectedSchool.SchoolID != this.SelectedSchool.SchoolID) {
				isSchoolChange = true;
			}

			if (isSchoolChange == true && this.SelectedSchool.SchoolID > 0) {
				let parms: wsPrintSchoolOptionsInfoParm = {
					SchoolID: this.SelectedSchool.SchoolID,
				};

				this.isBusy = true;
				this.dataService.IDPrintSchoolOptionsGet(parms).subscribe((data) => this.IDPrintSchoolOptionsGet_Complete(data));
				this.dataService.IDPrintQueueSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
		this.subscriptionPersonSelectMultiple.unsubscribe();
		this.subscriptionSchoolSelect.unsubscribe();
		this.subscriptionAudienceSelect.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ontoggleCardStock
	//
	//-----------------------------------------------------------------------------------------------------
	ontoggleCardStock() {
		this.isShowCardStock = !this.isShowCardStock;
		this.filterIDCardStockDesc.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintSchoolOptionsGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintSchoolOptionsGet_Complete(data: any) {
		this.rPrintSchoolOptions = data;
		this.DefaultFee = this.rPrintSchoolOptions.ReprintFee;
		this.isExpressIDCardPrintingMode = this.rPrintSchoolOptions.isExpressIDCardPrintingMode;

		this.Printer_GetPreference(); ////////////////////////////////////////////////////////////////////////////////////

		this.SetSchoolOptionPrinterSelector();
		this.SetSchoolOptionTemplateSelector();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	SetSchoolOptionPrinterSelector
	//
	//-----------------------------------------------------------------------------------------------------
	SetSchoolOptionPrinterSelector() {
		//	Make a copy, not a reference
		this.lstPrinter = JSON.parse(JSON.stringify(this.rPrintSchoolOptions.Printers));

		this.lstPrinter.unshift({
			IDPrinterID: -1,
			PrinterName: "- Select a printer",
			ScanStation: "",
		});

		this.SelectedPrinter = this.lstPrinter[0];

		if (this.LoadedPreference != undefined) {
			// console.log("Update Printer From Preference");
			// console.log(this.LoadedPreference.IDPrinterID);

			for (var i = 0; i < this.lstPrinter.length; i++) {
				var next = this.lstPrinter[i];

				if (next.IDPrinterID == this.LoadedPreference.IDPrinterID) {
					this.SelectedPrinter = next;
					break;
				}
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	SetSchoolOptionTemplateSelector
	//
	//-----------------------------------------------------------------------------------------------------
	SetSchoolOptionTemplateSelector() {
		//	Make a copy, not a reference
		this.lstStaffTemplate = JSON.parse(JSON.stringify(this.rPrintSchoolOptions.StaffTemplates));
		this.lstStaffTemplate.unshift({
			IDCardTemplateID: "",
			CardName: "- Select a staff card -",
		});

		this.SelectedStaffTemplate = this.lstStaffTemplate[0];

		//	Make a copy, not a reference
		this.lstStudentTemplate = JSON.parse(JSON.stringify(this.rPrintSchoolOptions.StudentTemplates));
		this.lstStudentTemplate.unshift({
			IDCardTemplateID: "",
			CardName: "- Select a student card -",
		});

		this.SelectedStudentTemplate = this.lstStudentTemplate[0];

		if (this.LoadedPreference != undefined) {
			// console.log("Update Template From Preference");
			// console.log(this.LoadedPreference.IDCardTemplateID);

			if (this.SelectedAudience == 1) {
				for (var i = 0; i < this.lstStudentTemplate.length; i++) {
					var next = this.lstStudentTemplate[i];

					if (next.IDCardTemplateID == this.LoadedPreference.IDCardTemplateID) {
						this.SelectedStudentTemplate = next;
						break;
					}
				}
			} else {
				for (var i = 0; i < this.lstStaffTemplate.length; i++) {
					var next = this.lstStaffTemplate[i];

					if (next.IDCardTemplateID == this.LoadedPreference.IDCardTemplateID) {
						this.SelectedStaffTemplate = next;
						break;
					}
				}
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSelectList_Complete(data: any) {
		this.lstPrintQueueChecked = [];
		this.lstPrintQueue = data;

		//
		//	Set Filter Lists
		//
		this.lstPersonTypes = Array.from(new Set(this.lstPrintQueue.map((item: any) => item.IsStaffDesc)));
		this.lstCardNames = Array.from(new Set(this.lstPrintQueue.map((item: any) => item.CardName)));
		this.lstCardStocks = Array.from(new Set(this.lstPrintQueue.map((item: any) => item.IDCardStockDesc)));
		this.lstPrinterNames = Array.from(new Set(this.lstPrintQueue.map((item: any) => item.PrinterName)));
		this.lstPrintQueueStatuses = Array.from(new Set(this.lstPrintQueue.map((item: any) => item.IDPrintQueueStatusDesc)));
		this.lstHasPhoto = Array.from(new Set(this.lstPrintQueue.map((item: any) => item.HasPhotoDesc)));

		this.onClearFilters();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrinterChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPrinterChange(e: any) {
		this.Printer_SetPreference();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStaffTemplateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStaffTemplateChange(e: any) {
		this.Printer_SetPreference();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStudentTemplateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStudentTemplateChange(e: any) {
		this.Printer_SetPreference();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAdd
	//
	//-----------------------------------------------------------------------------------------------------
	onAdd() {
		//
		// Add Select Person Message
		//
		if (this.lstSelectedPerson.length < 1) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "No persons selected. Please select one or more people.",
				header: "Add",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});

			return;
		}
		//
		// Add Select Printer Message
		//
		if (this.SelectedPrinter.IDPrinterID < 1) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "No printer selected. Please select a printer.",
				header: "Add",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});

			return;
		}

		//
		// Add Select Template Message
		//
		if (this.SelectedAudience == 2) {
			if (this.SelectedStaffTemplate.IDCardTemplateID.length < 10) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "No staff card selected. Please select a card.",
					header: "Add",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});

				return;
			}
		} else {
			if (this.SelectedStudentTemplate.IDCardTemplateID.length < 10) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "No student card selected. Please select a card.",
					header: "Add",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});

				return;
			}
		}

		//
		//	Get the selected person list from person selector {lstSelectedPerson}
		//
		if (
			this.lstSelectedPerson.length > 0 &&
			this.SelectedPrinter.IDPrinterID > 0 &&
			((this.SelectedAudience == 2 && this.SelectedStaffTemplate.IDCardTemplateID.length > 10) ||
				(this.SelectedAudience != 2 && this.SelectedStudentTemplate.IDCardTemplateID.length > 10))
		) {
			let lstPerson: wsPersonInfo[] = [];

			this.lstSelectedPerson.forEach((item) => {
				let r: wsPersonInfo = {
					PersonID: item,
				};

				lstPerson.push(r);
			});

			//
			//	Add Selected People To PrintQ
			//
			if (this.SelectedAudience == 2) {
				// Staff
				let parms: wsPrintQueueInsertParm = {
					Person: lstPerson,
					IDPrinterID: this.SelectedPrinter.IDPrinterID,
					IDCardTemplateID: this.SelectedStaffTemplate.IDCardTemplateID,
					IDPrintQueueStatusID: 1, // Review Pending
					ReprintFee: this.rPrintSchoolOptions.ReprintFee,
				};

				this.isBusy = true;
				this.dataService.IDPrintQueueInsert(parms).subscribe((data) => this.IDPrintQueueInsert_Complete(data));
			} else {
				// Student
				let parms: wsPrintQueueInsertParm = {
					Person: lstPerson,
					IDPrinterID: this.SelectedPrinter.IDPrinterID,
					IDCardTemplateID: this.SelectedStudentTemplate.IDCardTemplateID,
					IDPrintQueueStatusID: 1, // Review Pending
					ReprintFee: this.rPrintSchoolOptions.ReprintFee,
				};

				this.isBusy = true;
				this.dataService.IDPrintQueueInsert(parms).subscribe((data) => this.IDPrintQueueInsert_Complete(data));
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueInsert_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueInsert_Complete(data: any) {
		//
		//	Unselect Items In Person Selector
		//
		this.personselectorService.UnselectItems();

		//
		//	Refresh Q
		//
		this.isBusy = true;
		this.dataService.IDPrintQueueSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {
		this.lstPrintQueueChecked = [];
	}

	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClearFilters
	//
	//-----------------------------------------------------------------------------------------------------
	onClearFilters() {
		this.filterHasPhoto.clear(null);
		this.filterIsStaffDesc.clear(null);
		this.filterCardName.clear(null);
		this.filterIDCardStockDesc.clear(null);
		this.filterPrinterName.clear(null);
		this.filterIDPrintQueueStatusDesc.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.isBusy = true;
		this.dataService.IDPrintQueueSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDelete
	//
	//-----------------------------------------------------------------------------------------------------
	onDelete() {
		//
		// Validate Delete PrintQ Items
		//
		if (this.lstPrintQueueChecked.length < 1) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "There are no selected items in the print queue.",
				header: "Delete",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});

			return;
		} else {
			//
			// Confirm Delete
			//
			var strWork = "";

			if (this.lstPrintQueueChecked.length == 1) {
				strWork = "Item";
			} else {
				strWork = "Items";
			}

			var message =
				"You are about to delete " +
				this.lstPrintQueueChecked.length +
				" " +
				strWork +
				" " +
				"from the print queue.<br><br>" +
				"Do you wish to continue?";

			this.confirmationService.confirm({
				message: message,
				header: "Delete",
				icon: "fa fa-info",
				accept: () => {
					this.onDeleteConfirmed();
				},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDeleteConfirmed
	//
	//-----------------------------------------------------------------------------------------------------
	onDeleteConfirmed() {
		let parms: wsPrintQueueDeleteParm = {
			DeleteItems: [],
		};

		this.lstPrintQueueChecked.forEach((item) => {
			let r: wsDeleteInfo = {
				IDPrintQueueID: item.IDPrintQueueID,
			};

			parms.DeleteItems.push(r);
		});

		this.isBusy = true;
		this.dataService.IDPrintQueueDelete(parms).subscribe((data) => this.IDPrintQueueDelete_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueDelete_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueDelete_Complete(data: any) {
		this.isBusy = true;
		this.dataService.IDPrintQueueSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetPrinter
	//
	//-----------------------------------------------------------------------------------------------------
	onSetPrinter() {
		//
		//	Set Printer
		//
		if (this.lstPrintQueueChecked.length > 0) {
			var isExpressIDCardPrinting = this.isExpressIDCardPrintingMode;
			var lstChecked = this.lstPrintQueueChecked.filter(function (obj) {
				// 1 = Review Pending, 2 = Print Pending
				return obj.IDPrintQueueStatusID == 1 || (isExpressIDCardPrinting == true && obj.IDPrintQueueStatusID == 2);
			});

			//
			//	Validate we have at least 1 [Review Pending] item selected.
			//
			if (lstChecked.length == 0) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "There are no selected items in the print queue with a status of [Review Pending]",
					header: "Set Printer",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});

				return;
			}

			if (lstChecked.length > 0) {
				var ref = this.dialogService.open(SetPrinterComponent, {
					header: "Set Printer",
					width: "500px",
					data: {
						lstPrintQueueChecked: lstChecked,
						lstPrinter: JSON.parse(JSON.stringify(this.rPrintSchoolOptions.Printers)), //	Make a copy, not a reference
					},
				});
				ref.onClose.subscribe((response) => {
					if (response == 1) {
						//
						//	Refresh PrintQ
						//
						this.isBusy = true;
						this.dataService.IDPrintQueueSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
					}
				});
			}
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "There are no selected items in the print queue.",
				header: "Set Printer",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetCard
	//
	//-----------------------------------------------------------------------------------------------------
	onSetCard() {
		//
		//	Set Card
		//
		if (this.lstPrintQueueChecked.length > 0) {
			var isExpressIDCardPrinting = this.isExpressIDCardPrintingMode;
			var lstChecked = this.lstPrintQueueChecked.filter(function (obj) {
				// 1 = Review Pending, 2 = Print Pending
				return obj.IDPrintQueueStatusID == 1 || (isExpressIDCardPrinting == true && obj.IDPrintQueueStatusID == 2);
			});

			//
			//	Validate we have at least 1 [Review Pending] item selected.
			//
			if (lstChecked.length == 0) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "There are no selected items in the print queue with a status of [Review Pending].",
					header: "Set Card",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});

				return;
			}

			if (lstChecked.length > 0) {
				var ref = this.dialogService.open(SetCardComponent, {
					header: "Set Card",
					width: "500px",
					data: {
						lstPrintQueueChecked: lstChecked,
						lstStaffCard: JSON.parse(JSON.stringify(this.rPrintSchoolOptions.StaffTemplates)), //	Make a copy, not a reference
						lstStudentCard: JSON.parse(JSON.stringify(this.rPrintSchoolOptions.StudentTemplates)), //	Make a copy, not a reference
					},
				});
				ref.onClose.subscribe((response) => {
					if (response == 1) {
						//
						//	Refresh PrintQ
						//
						this.isBusy = true;
						this.dataService.IDPrintQueueSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
					}
				});
			}
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "There are no selected items in the print queue.",
				header: "Set Card",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetFee
	//
	//-----------------------------------------------------------------------------------------------------
	onSetFee() {
		//
		//	Set Fee
		//
		if (this.lstPrintQueueChecked.length > 0) {
			var isExpressIDCardPrinting = this.isExpressIDCardPrintingMode;
			var lstChecked = this.lstPrintQueueChecked.filter(function (obj) {
				// 1 = Review Pending (Student Only), 2 = Print Pending (Student Only)
				return (
					(obj.IDPrintQueueStatusID == 1 && obj.IsStaff == false) ||
					(isExpressIDCardPrinting == true && obj.IDPrintQueueStatusID == 2 && obj.IsStaff == false)
				);
			});

			//
			//	Validate we have at least 1 [Review Pending] item selected.
			//
			if (lstChecked.length == 0) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "There are no selected items of type Student in the print queue with a status of [Review Pending].",
					header: "Set Fee",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});

				return;
			}

			if (lstChecked.length > 0) {
				var ref = this.dialogService.open(SetFeeComponent, {
					header: "Set Fee",
					width: "500px",
					data: {
						lstPrintQueueChecked: lstChecked,
						DefaultFee: this.DefaultFee,
					},
				});
				ref.onClose.subscribe((response) => {
					if (response == 1) {
						//
						//	Refresh PrintQ
						//
						this.isBusy = true;
						this.dataService.IDPrintQueueSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
					}
				});
			}
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "There are no selected items in the print queue.",
				header: "Set Fee",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		//
		//	Print
		//
		if (this.lstPrintQueueChecked.length > 0) {
			//
			//	Filter List and make sure all have a valid status/card/printer - [Review Pending] or [Printed]
			//
			var lstChecked = this.lstPrintQueueChecked.filter(function (obj) {
				return (obj.IDPrintQueueStatusID == 1 || obj.IDPrintQueueStatusID == 3) && obj.IDCardTemplateID.length > 10 && obj.IDPrinterID > 0;
			});

			if (lstChecked.length == 0) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message:
						"There are no selected items in the print queue with a valid Card Name and Printer Name that have a status of [Review Pending] or [Printed].",
					header: "Print",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});

				return;
			}

			//
			//	All Items Must be using the same Audience (Student or Staff)
			//
			var lstCheckAudience = [];

			lstChecked.forEach(function (item) {
				var i = lstCheckAudience.findIndex((x) => x.IsStaff == item.IsStaff);

				if (i <= -1) {
					lstCheckAudience.push({
						IsStaff: item.IsStaff,
						IsStaffDesc: item.IsStaffDesc,
					});
				}
			});

			if (lstCheckAudience.length > 1) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "All selected items must be only Students or only Staff.",
					header: "Print",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});

				return;
			}

			//
			//	All Items Must be using the same printer
			//
			var lstCheckPrinter = [];

			lstChecked.forEach(function (item) {
				var i = lstCheckPrinter.findIndex((x) => x.IDPrinterID == item.IDPrinterID);

				if (i <= -1) {
					lstCheckPrinter.push({
						IDPrinterID: item.IDPrinterID,
						PrinterName: item.PrinterName,
					});
				}
			});

			if (lstCheckPrinter.length > 1) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "All selected items must be using the same printer.",
					header: "Print",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});

				return;
			}

			//
			//	All Items Must be using the same card stock
			//
			var lstCheckStock = [];

			lstChecked.forEach(function (item) {
				var i = lstCheckStock.findIndex((x) => x.IDCardStockID == item.IDCardStockID);

				if (i <= -1) {
					lstCheckStock.push({
						IDCardStockID: item.IDCardStockID,
						IDCardStockDesc: item.IDCardStockDesc,
					});
				}
			});

			if (lstCheckStock.length > 1) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "All selected items must be using the same card stock.",
					header: "Print",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});

				return;
			}

			//
			//	Validations Passed
			//
			if (lstChecked.length > 0 && lstCheckPrinter.length == 1 && lstCheckStock.length == 1) {
				var ref = this.dialogService.open(PrintComponent, {
					header: "Print",
					width: "500px",
					data: {
						SchoolID: this.SelectedSchool.SchoolID,
						lstPrintQueueChecked: lstChecked,
					},
				});
				ref.onClose.subscribe((response) => {
					if (response == 1) {
						//
						//	Refresh PrintQ
						//
						this.isBusy = true;
						this.dataService.IDPrintQueueSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
					}
				});
			}
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "There are no selected items in the print queue.",
				header: "Print",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCancelPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onCancelPrint() {
		//
		// Validate Cancel PrintQ Print
		//
		var lstCancel = this.lstPrintQueueChecked.filter(function (obj) {
			return obj.IDPrintQueueStatusID == 2 || obj.IDPrintQueueStatusID == 5; //  2 = Print Pending, 5 = Printing
		});

		if (lstCancel.length < 1) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "There are no selected items in the print queue with a status of [Print Pending] or [Printing].",
				header: "Cancel Print",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});

			return;
		} else {
			//
			// Confirm Cancel
			//
			var strWork = "";

			if (lstCancel.length == 1) {
				strWork = "Item";
			} else {
				strWork = "Items";
			}

			var message =
				"You are about to cancel printing " +
				lstCancel.length +
				" " +
				strWork +
				" " +
				"from the print queue with a status of [Print Pending] or [Printing].<br><br>" +
				"Do you wish to continue?";

			this.confirmationService.confirm({
				message: message,
				header: "Cancel Print",
				icon: "fa fa-info",
				accept: () => {
					this.onCancelConfirmed();
				},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCancelConfirmed
	//
	//-----------------------------------------------------------------------------------------------------
	onCancelConfirmed() {
		var lstCancel = this.lstPrintQueueChecked.filter(function (obj) {
			return obj.IDPrintQueueStatusID == 2 || obj.IDPrintQueueStatusID == 5; //  2 = Print Pending, 5 = Printing
		});

		let parms: wsPrintQueueCancelParm = {
			CancelItems: [],
		};

		lstCancel.forEach((item) => {
			let r: wsCancelInfo = {
				IDPrintQueueID: item.IDPrintQueueID,
			};

			parms.CancelItems.push(r);
		});

		this.isBusy = true;
		this.dataService.IDPrintQueueCancel(parms).subscribe((data) => this.IDPrintQueueCancel_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueCancel_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueCancel_Complete(data: any) {
		this.isBusy = true;
		this.dataService.IDPrintQueueSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Printer_UpdatePreferenceKey
	//
	//-----------------------------------------------------------------------------------------------------
	Printer_UpdatePreferenceKey() {
		// console.log("School");
		// console.log(this.SelectedSchool);
		// console.log("Person Type");
		// console.log(this.SelectedAudience);

		this.PrinterPref = "Printing_" + this.SelectedSchool.SchoolID + "_" + this.SelectedAudience;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Printer_GetPreference
	//
	//-----------------------------------------------------------------------------------------------------
	Printer_GetPreference() {
		// console.log("Checking Local Storage Preference " + this.PrinterPref);
		this.LoadedPreference = this.localService.getItem(this.PrinterPref);
		// console.log(this.LoadedPreference);

		if (this.LoadedPreference != undefined) {
			// console.log("Update Printer From Preference");
			// console.log(this.LoadedPreference.Printer);

			this.SelectedPrinter = this.lstPrinter[0];

			for (var i = 0; i < this.lstPrinter.length; i++) {
				var nextPrinter = this.lstPrinter[i];

				if (nextPrinter.IDPrinterID == this.LoadedPreference.IDPrinterID) {
					this.SelectedPrinter = nextPrinter;
					break;
				}
			}

			// console.log("Update Template From Preference");
			// console.log(this.LoadedPreference.IDCardTemplateID);

			this.SelectedStudentTemplate = this.lstStudentTemplate[0];
			this.SelectedStaffTemplate = this.lstStaffTemplate[0];

			if (this.SelectedAudience == 1) {
				for (var i = 0; i < this.lstStudentTemplate.length; i++) {
					var nextStudentTemplate = this.lstStudentTemplate[i];

					if (nextStudentTemplate.IDCardTemplateID == this.LoadedPreference.IDCardTemplateID) {
						this.SelectedStudentTemplate = nextStudentTemplate;
						break;
					}
				}
			} else {
				for (var i = 0; i < this.lstStaffTemplate.length; i++) {
					var nextStaffTemplate = this.lstStaffTemplate[i];

					if (nextStaffTemplate.IDCardTemplateID == this.LoadedPreference.IDCardTemplateID) {
						this.SelectedStaffTemplate = nextStaffTemplate;
						break;
					}
				}
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Printer_SetPreference
	//
	//-----------------------------------------------------------------------------------------------------
	Printer_SetPreference() {
		// console.log("Setting Local Storage Preference " + this.PrinterPref);

		var data: any;

		if (this.SelectedAudience == 1) {
			data = {
				IDPrinterID: this.SelectedPrinter.IDPrinterID,
				IDCardTemplateID: this.SelectedStudentTemplate.IDCardTemplateID,
			};
		} else {
			data = {
				IDPrinterID: this.SelectedPrinter.IDPrinterID,
				IDCardTemplateID: this.SelectedStaffTemplate.IDCardTemplateID,
			};
		}

		this.localService.setItem(this.PrinterPref, data);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
